import { BadgeId } from './Models';
import { createStandardAction, createAsyncAction } from 'typesafe-actions';

export const unlockBadge = createStandardAction('@@badges/UNLOCK')<BadgeId[]>();

export const onBadgesChanged = createStandardAction('@@badges/SYNC')<void>();

export const syncBadges = createAsyncAction('@@badges/SYNC_REQUEST', '@@badges/SYNC_SUCCESS', '@@badges/SYNC_ERROR')<
  any,
  any,
  Error
>();



// WEBPACK FOOTER //
// ./src/containers/Badges/actions.ts